// extracted by mini-css-extract-plugin
export default {"wrapper":"_520a7d3a","headerBackground":"_a5dc1998","barHeader":"_24f20be7"};